import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en.json";
import fr from "@/locales/fr.json";
import de from "@/locales/de.json";
import it from "@/locales/it.json";
import es from "@/locales/es.json";
import al from "@/locales/al.json";
// Iter 67dy — beta languages (auto-translated via Gemini 3 Pro, not yet
// human-reviewed). Surfaced behind a "Beta" badge in the language switcher
// so renters who choose them know to expect rough edges.
import pt from "@/locales/pt.json";
import pl from "@/locales/pl.json";
import ro from "@/locales/ro.json";
import el from "@/locales/el.json";
import bg from "@/locales/bg.json";
import tr from "@/locales/tr.json";
import ru from "@/locales/ru.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "EN", flag: "🇬🇧", name: "English" },
  { code: "fr", label: "FR", flag: "🇫🇷", name: "Français" },
  { code: "de", label: "DE", flag: "🇩🇪", name: "Deutsch" },
  { code: "it", label: "IT", flag: "🇮🇹", name: "Italiano" },
  { code: "es", label: "ES", flag: "🇪🇸", name: "Español" },
  { code: "al", label: "AL", flag: "🇦🇱", name: "Shqip" },
  // Beta — auto-translated, surfaced for renter coverage across the Balkans
  // and broader Europe. Switcher renders a "Beta" pill next to these.
  { code: "pt", label: "PT", flag: "🇵🇹", name: "Português", beta: true },
  { code: "pl", label: "PL", flag: "🇵🇱", name: "Polski",    beta: true },
  { code: "ro", label: "RO", flag: "🇷🇴", name: "Română",    beta: true },
  { code: "el", label: "EL", flag: "🇬🇷", name: "Ελληνικά",  beta: true },
  { code: "bg", label: "BG", flag: "🇧🇬", name: "Български", beta: true },
  { code: "tr", label: "TR", flag: "🇹🇷", name: "Türkçe",    beta: true },
  { code: "ru", label: "RU", flag: "🇷🇺", name: "Русский",   beta: true },
];

const STORAGE_KEY = "rentalcar_lang";

const stored = (() => {
  // localStorage throws in private-mode Safari and sandboxed iframes — degrade
  // gracefully to the default language rather than crashing the bundle.
  try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
      es: { translation: es },
      al: { translation: al },
      pt: { translation: pt },
      pl: { translation: pl },
      ro: { translation: ro },
      el: { translation: el },
      bg: { translation: bg },
      tr: { translation: tr },
      ru: { translation: ru },
    },
    lng: stored || "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export function setLanguage(code) {
  if (!SUPPORTED_LANGUAGES.find((l) => l.code === code)) return;
  i18n.changeLanguage(code);
  // Same private-mode story — preference persistence is best-effort.
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* storage disabled; preference will not persist */ }
}

export default i18n;
